
import TitleService from 'title-service';
import './NetflixNextEpisode.scss';
export default function NetflixNextEpisode(props: any) {
    return (
        <div className="nfa-pos-abs nfa-bot-6-em nfa-right-5-em nfa-d-flex thisone">
            <button className="color-secondary hasLabel ltr-v8pdkb"
                onClick={() => {
                    if (props.onShowControls) {
                        props.onShowControls();
                    }
                }}
                data-uia="watch-credits-seamless-button" type="button">
                <span className="ltr-zd4xih">{TitleService('See generic')}</span>
            </button>
            <div className="ltr-1i33xgl" style={{ "width": "1.25rem" }}>
            </div>
            <button
                className="color-primary hasLabel hasIcon ltr-v8pdkb"
                onClick={() => {
                    if (props.onPlay) {
                        props.onPlay();
                    }
                }}
                data-uia="next-episode-seamless-button" type="button">
                <div className="ltr-1ksxkn9">
                    <div className="medium ltr-18dhnor" role="presentation" style={{ color: 'black' }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                            <path d="M4 2.69127C4 1.93067 4.81547 1.44851 5.48192 1.81506L22.4069 11.1238C23.0977 11.5037 23.0977 12.4963 22.4069 12.8762L5.48192 22.1849C4.81546 22.5515 4 22.0693 4 21.3087V2.69127Z" fill="currentColor">
                            </path>
                        </svg>
                    </div>
                </div>
                <div className="ltr-1i33xgl" style={{ "width": "1rem" }}>
                </div>
                <span className="ltr-zd4xih" style={{ color: 'black' }}>{TitleService('Next Episode')}</span>
            </button>
        </div>
    );
}